// IMPORT PACKAGE REFERENCES
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { PathwayReferenceHelper } from '../../PathwayReferenceHelper'; 
import { GPChestPainPathwayReference } from '../GPChestPainPathway-Reference';
import { FormsContentType, FormsStyles } from '../../../waferJS/FormsUI/FormsUI';
import { GPChestPainCalculationHelper } from '../Helpers/GPChestPainCalculationHelper';
import { PrintHeader } from '../../../components/shared/PrintHeader';
import { calculateEWS, EWSCategory, TotalEWS } from '../Custom Types/EWS';

import moment from 'moment';

import '../../../styles/components/formSummary.scss';
import { CalculationModel } from  '../Custom Types/Calculation';
import { TroponinResult } from '../Custom Types/Troponin';

import { FormLoader } from '../../FormLoader';

// COMPONENT
class GPChestPainSummary extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            complete: 0,
            total: 0,
            actions: [],
            exportHCSVisible: false,
            data: GPChestPainPathwayReference.data,
            mainForm: FormLoader.form(this.props.pathwayId , 'mainForm')
        };

        this.formatDate = this.formatDate.bind(this);
        this.getItemsInSection = this.getItemsInSection.bind(this);
        this.getReadableValue = this.getReadableValue.bind(this);
        this.generateStemi = this.generateStemi.bind(this);
        this.generateAbnormalities = this.generateAbnormalities.bind(this);
        this.getMissingDetail = this.getMissingDetail.bind(this);
        this.formatList = this.formatList.bind(this);
        this.getDisparateItemsAsList = this.getDisparateItemsAsList.bind(this);
        this.getCalculationBadge = this.getCalculationBadge.bind(this);
        this.getRedFlagsBadge = this.getRedFlagsBadge.bind(this);
        this.getSummary = this.getSummary.bind(this);
        this.getRedFlagOverrideReasons = this.getRedFlagOverrideReasons.bind(this);
        this.areRedFlagPresents = this.areRedFlagPresents.bind(this);
        this.getMandatoryDetail = this.getMandatoryDetail.bind(this);
        this.getEWSBadge = this.getEWSBadge.bind(this);
        this.getTotalEWSBadge = this.getTotalEWSBadge.bind(this);
        this.getBadgeValue = this.getBadgeValue.bind(this);
        this.stripSpecialChars = this.stripSpecialChars.bind(this);
    }

    componentDidMount(){
        let pathwayProgress = this.state.mainForm.completionProgress(['followUpBloodsDateAndTime', 'followUpBloodsTroponin']);
        if(pathwayProgress != null){
            this.setState({
                complete: pathwayProgress.current,
                total: pathwayProgress.total
            });
        } else {
            this.setState({
                complete: 0,
                total: 0
            });
        }

        let formActions = this.props.actions[this.props.pathwayId];
        if(formActions != null){
            this.setState({actions: formActions});
        }
    }

    getReadableDate(workflow, identifier, format, isDefaultStyle, isMandatory) {
        let date = workflow.rawData[identifier];
        if (date == null) {
            if(!isMandatory){
                return this.getMissingDetail(identifier);
            }
            return this.getMandatoryDetail(identifier);
        }
        return <label className={'list-detail '}>{this.formatDate(date, format)}</label>;
    }

    formatDate(date, format) {
        if (date == null) { return null; }
        return moment(date).format(format);
    }

    getMissingDetail(identifier) {
        let reference = PathwayReferenceHelper.reference(identifier, this.state.data);
        return <label className={'not-present list-detail'}>[{reference.title}]</label>;
    }

    getMandatoryDetail(identifier) {
        let reference = PathwayReferenceHelper.reference(identifier,  this.state.data);
        return <label className={'absent list-detail'}>[{reference.title}]</label>;
    }

    getItemsInSection(workflow, identifiers, valueState, tag, openingString, closingString, lineBreak) {
        let filteredItems = [];
        for (let identifier of identifiers) {
            let listReference = PathwayReferenceHelper.reference(identifier, this.state.data);
            filteredItems = filteredItems.concat(
                listReference[PathwayReferenceHelper.Type.sectionChildIDs].filter((itemID) => {
                    return workflow.rawData[itemID] == valueState;
                })
            );
        }

        if (filteredItems.length == 0) { return ''; }

        return this.formatList(filteredItems, tag, openingString, closingString, lineBreak, workflow);
    }

    getDisparateItemsAsList(workflow, identifiers, valueState, tag, openingString, closingString, lineBreak) {
        let filteredItems = identifiers.filter((itemID) => {
            if (workflow.rawData[itemID + 'Override'] == true) {
                return workflow.rawData[itemID + 'OverrideValue'] == valueState;
            } else {
                return workflow.rawData[itemID] == valueState;
            }
        });

        if (filteredItems.length == 0) { return ''; }

        return this.formatList(filteredItems, tag, openingString, closingString, lineBreak);
    }

    formatList(identifiers, tag, openingString, closingString, lineBreak, workflow) {
        return (<label className={'list-detail ' + tag} key={tag + identifiers[0]}>
            {openingString} {identifiers.map((itemID) => {
                if (!lineBreak) {
                    return (
                        (PathwayReferenceHelper.reference(itemID, this.state.data).title.includes(',') ? '\'' : '') + PathwayReferenceHelper.reference(itemID, this.state.data).title + (PathwayReferenceHelper.reference(itemID, GPChestPainPathwayReference.data).title.includes(',') ? '\'' : '') + (itemID != identifiers[identifiers.length - 1] ? ', ' : '')
                    );
                }

                if(itemID == 'alternativeFinding'){
                    return (
                        <span className="detail-list-span-vertical" key={itemID}>{('Alternative finding: ' + (workflow.rawData['alternativeFindingSpecify'] == null ? '[Alternative Finding]' : workflow.rawData['alternativeFindingSpecify']))} <br /></span>
                    );
                }

                return (
                    <span className="detail-list-span-vertical" key={itemID}>{PathwayReferenceHelper.reference(itemID, this.state.data).title + (itemID != identifiers[identifiers.length - 1] ? ',' : '')} <br /></span>
                );
            })}{closingString}
        </label>);
    }

    getReadableValue(workflow, identifier, isMandatory) {
        let reference = PathwayReferenceHelper.reference(identifier, this.state.data);
        let value = workflow.rawData[identifier];
        let unit = reference[PathwayReferenceHelper.Type.textEntryUnitText];
        if (value == null) { 
            if(isMandatory){
                return this.getMandatoryDetail(identifier);
            }
            return this.getMissingDetail(identifier); 
        }

        switch (reference[PathwayReferenceHelper.Type.controlType]) {
            case FormsContentType.ControlType.plain:
            case FormsContentType.ControlType.badge:
            case FormsContentType.ControlType.calculation:
            case FormsContentType.ControlType.action:
            case FormsContentType.ControlType.picker:
            case FormsContentType.ControlType.weblink:
            case FormsContentType.ControlType.textEntry: {
                if(identifier == 'initialBloodsTroponin' || identifier == 'followUpBloodsTroponin'){
                    if(value < 2) {
                        return '<2' + (unit == null ? '' : unit);
                    }
                } 
                return value + (unit == null ? '' : unit);
            }
            case FormsContentType.ControlType.radio:
                return value == true ? 'Yes' : 'No';
            case FormsContentType.ControlType.selection:
                if (reference[PathwayReferenceHelper.Type.selectionType] == FormsContentType.SelectionType.explicit) {
                    return value == true ? 'Yes' : 'No';
                } else if (reference[PathwayReferenceHelper.Type.selectionType] == FormsContentType.SelectionType.simple) {
                    let optionReference = PathwayReferenceHelper.reference(value, this.state.data);
                    return optionReference.title;
                }
        }

        if(isMandatory){
            return this.getMandatoryDetail(identifier);
        }
        return this.getMissingDetail(identifier);
    }

    generateStemi(workflow) {
        let stemiPresent = workflow.rawData['stemiPresent'];

        if (stemiPresent == null) { return <label className={'list-detail absent'}>[STEMI present]</label>; }
        if (stemiPresent != null && stemiPresent) {
            return (
                <span className={'detail-list-span-vertical'}>
                    {this.getItemsInSection(workflow, ['stemiCriteriaSection'], true, 'present-items', '', '', true)}
                    {/* {this.getItemsInSection(workflow, ['stemiCriteriaSection'], false, 'not-present', 'Not present: ', '', false)} */}
                    {this.getItemsInSection(workflow, ['stemiCriteriaSection'], null, 'absent', '[Not specified: ', ']', false)}
                </span>
            );
        } else {
            return (<label className={'list-detail minor-detail'}>No STEMI criteria present</label>);
        }
    }

    generateAbnormalities(workflow) {
        let stemiPresent = workflow.rawData['abnormalitiesPresent'];

        if (stemiPresent == null) { return <label className={'list-detail absent'}>[Other abnormalities present]</label>; }
        if (stemiPresent != null && stemiPresent) {
            return (
                <span className={'detail-list-span-vertical'}>
                    {this.getItemsInSection(workflow, ['abnormalitiesCriteriaSection'], true, 'present-items', '', '', true)}
                    {this.getItemsInSection(workflow, ['abnormalitiesCriteriaSection'], false, 'not-present', 'Not present: ', '', false)}
                    {this.getItemsInSection(workflow, ['abnormalitiesCriteriaSection'], null, 'absent', '[Not specified: ', ']', false)}
                </span>
            );
        } else {
            return (<label className={'list-detail minor-detail'}>No Other abnormalities present</label>);
        }
    }

    getCalculationBadge(workflow, calculationType, identifier) {
        let error = GPChestPainCalculationHelper.calcualtionError(identifier, workflow.rawData, this.state.mainForm);
        
        if(error != null){
            return <label className='list-detail' style={{color: FormsStyles.orange}}>{error.message}</label>;
        }

        if(this.state.complete == 0 && this.state.total == 0){
            return this.getMandatoryDetail(identifier);
        }

        if(((calculationType == CalculationModel.CalculationType.riskCategory) && (this.state.complete / this.state.total) != 1)){
            return this.getMandatoryDetail(identifier);
        }

        let calculation = GPChestPainCalculationHelper.getLatestCalculation(calculationType, this.props.calculations[this.props.pathwayId]);
        if (calculation == null) { return this.getMandatoryDetail(identifier); }

        let badgeStyle = { 
            backgroundColor: calculation.badgeColor == null ? FormsStyles.backgroundColor : calculation.badgeColor,
            color: calculation.badgeColor == null ? 'black' : 'white',
        };

        return <label className='tag' style={badgeStyle}>{calculation.valueString}</label>;
    }

    getAction(action) {
        let title = action.title == null ? PathwayReferenceHelper.reference(action.identifier, this.state.data).title : action.title;
        let detail = action.detail == null ? PathwayReferenceHelper.reference(action.identifier, this.state.data).detail : action.detail;
        title = this.stripSpecialChars(title);
        detail = this.stripSpecialChars(detail);
        return (
            <span key={action.uuid} className='detail-list-span-vertical'>
                <label className='list-title'>{title}</label>
                <label className='list-detail'>{detail}</label>
            </span>
        );
    }

    getActions(){
        let sections = [
            'alerts',
            'recommendedActions',
            'investigationsResults'
        ];

        return (
            <span className="detail-list-span-vertical">
                {
                    sections.map((section) => {
                        let actionsForSections = PathwayReferenceHelper.reference(section, this.state.data)[PathwayReferenceHelper.Type.sectionChildIDs];
                        
                        return (
                            actionsForSections.map((childID) => { return this.state.actions.filter((action) => {return action.identifier == childID;}).length > 0 ? true : null; }).filter(n => n).length > 0 &&
                            <div key ={section} style={{marginBottom: sections[sections.length - 1] == section ? '0' : '1em'}}>
                                <div className="actions-list-title">{PathwayReferenceHelper.reference(section, this.state.data).title}</div>
                                {actionsForSections.map((actionIdentifier) => {
                                    let filteredActions = this.state.actions.filter((action) => {return action.identifier == actionIdentifier;});
                                    
                                    if(filteredActions.length > 0){
                                        let action = filteredActions[0];
                                        
                                        let title = action.title == null ? PathwayReferenceHelper.reference(action.identifier, this.state.data).title : action.title;
                                        let detail = action.detail == null ? PathwayReferenceHelper.reference(action.identifier, this.state.data).detail : action.detail;
                                        title = this.stripSpecialChars(title);
                                        detail = this.stripSpecialChars(detail);
                                        
                                        return <span key={action.uuid} className='detail-list-span-vertical'>
                                            <label className='list-title'>{title}</label>
                                            <label className='list-detail'>{detail}</label>
                                        </span>;
                                    }
                                    return null;
                                })}
                            </div>
                        );
                    })
                }
            </span>
        );
    }

    getRedFlagsBadge(workflow) {
        let totalRedFlags = workflow.rawData['totalRedFlags'];
        if (totalRedFlags != null && totalRedFlags > 0) {
            return (<label className='tag' style={{ backgroundColor: 'red' }}>{totalRedFlags + ' ALERT' + (totalRedFlags == 1 ? '' : 'S')}</label>);
        }
        return ('');
    }

    getRedFlagOverrideReasons(workflow) {
        let redflags = [
            'aorticDissectionPresentRedFlag',
            'pulmonaryEmbolismRedFlag',
            'pancreatitisRedFlag',
            'pericarditisRedFlag',
            'pneumothoraxRedFlag',
            'cardiotoxicityRedFlag',
            'troponinAboveCutOff',
            'newIschaemicChanges',
            'redFlagsOngoingChestPain',
            'crescendoAngina',
            'haemodynamicInstability'
        ];

        let overrideValues = redflags.filter((overrideID) => {
            if (workflow.rawData[overrideID + 'Override'] == true) {
                return true;
            }
            return null;
        }).filter(n => n);

        return (
            overrideValues.length > 0 &&
            <span className='detail-list-span-vertical'>

                <label className='list-title'>{'Red Flag Override Reasons'}</label>
                {overrideValues.map((redFlag) => {
                    return (<label key={redFlag} className='list-detail'>{PathwayReferenceHelper.reference(redFlag, this.state.data).title + ': '} {(workflow.rawData[redFlag + 'OverrideReason'] != null ? workflow.rawData[redFlag + 'OverrideReason'] : this.getMissingDetail(redFlag + 'OverrideReason'))}</label>);
                })}

            </span>
        );
    }

    areRedFlagPresents(workflow) {
        let redflags = [
            'aorticDissectionPresentRedFlag',
            'pulmonaryEmbolismRedFlag',
            'pancreatitisRedFlag',
            'pericarditisRedFlag',
            'pneumothoraxRedFlag',
            'cardiotoxicityRedFlag',
            'troponinAboveCutOff',
            'newIschaemicChanges',
            'redFlagsOngoingChestPain',
            'crescendoAngina',
            'haemodynamicInstability'
        ];

        return redflags.map((redFlag) => {
            if (workflow.rawData[redFlag + 'Override'] == true) {
                return workflow.rawData[redFlag + 'OverrideValue'] != null ? true : null;
            } else {
                return workflow.rawData[redFlag] != null ? true : null;
            }
        }).filter(n => n).length > 0;

    }

    sectionContainsValue(workflow, values, identifiers){
        return identifiers.map((identifier) => {
            if (workflow.rawData[identifier + 'Override'] == true) {
                return values.includes(workflow.rawData[identifier + 'OverrideValue']);
            }
            return values.includes(workflow.rawData[identifier]);
        }).includes(true);
    }

    getEWSBadge(workflow, identifier){
        let value = workflow.rawData[identifier];
        let ews = calculateEWS(identifier + 'EWS', value);

        if(ews != null && ews.type != EWSCategory.Type.white){
            return (<label className='tag' style={{ backgroundColor: ews.color }}>{ews.score}</label>);
        }
        return null;
    }

    

    getTotalEWSBadge(workflow){
        let identifiers = [
            'heartRateEWS',
            'bloodPressureEWS',
            'bodyTemperatureEWS',
            'oxygenSaturationEWS',
            'respiratoryRateEWS',
            'supplementalOxygenEWS',
            'levelOfConsciousnessEWS'
        ];
        let categories = identifiers.map((identifier) => {
            let value = workflow.rawData[identifier.replace('EWS', '')];
            return calculateEWS(identifier, value);
        }).filter(n => n);

        if (categories.length == 0) {
            return null;
        }
        let totalEWS = new TotalEWS(categories);
        if (totalEWS != null) {
            return (<label className='tag' style={{ backgroundColor: totalEWS.sum > 0 ? totalEWS.color : FormsStyles.backgroundColor, color:  totalEWS.sum <= 0 ? totalEWS.color : 'white' }}>{totalEWS.title}</label>);
        }
        return null;
    }

    getVitals(workflow) {
        var identifiers = [
            'heartRate',
            'bloodPressure',
            'bodyTemperature',
            'oxygenSaturation',
            'respiratoryRate',
            'supplementalOxygen',
            'levelOfConsciousness'
        ];

        let values = identifiers.map((identifier) => {
            switch(identifier){
                case 'heartRate':
                    return <span key={identifier} style={{marginRight: '0.5em'}}>HR: {this.getReadableValue(workflow, identifier, true)},</span>;
                case 'bloodPressure':
                    return <span key={identifier} style={{marginRight: '0.5em'}}>BP:  {this.getReadableValue(workflow, identifier, true)},</span>; 
                case 'bodyTemperature':
                    return <span key={identifier} style={{marginRight: '0.5em'}}>T: {this.getReadableValue(workflow, identifier, true)},</span>;
                case 'oxygenSaturation':
                    return <span key={identifier} style={{marginRight: '0.5em'}}>SpO₂: {this.getReadableValue(workflow, identifier, true)},</span>;
                case 'respiratoryRate':
                    return <span key={identifier} style={{marginRight: '0.5em'}}>RR: {this.getReadableValue(workflow, identifier, true)},</span>;
                case 'supplementalOxygen':
                    return <span key={identifier} style={{marginRight: '0.5em'}}>Supplemental oxygen: {this.getReadableValue(workflow, identifier, true)},</span>;
                case 'levelOfConsciousness':
                    return <span key={identifier}>Level of consciousness: {this.getReadableValue(workflow, identifier, true)}</span>;
            }
        });

        

        return <span> {values.map((vital) => {
            return vital;
        })} </span>;
    }

    getBadgeValue(identifier, workflow){
       
        switch (identifier) {
            case 'ecgTest': {
                var badges = [];

                let stemiPresentValue = workflow.rawData['stemiPresent'];
                if (stemiPresentValue != null && stemiPresentValue) {
                    badges.push(<label key={'ecg-stemi'} className='tag' style={{ backgroundColor: FormsStyles.red, color: 'white' }}>STEMI</label>);
                }

                let abnormalitiesPresentValue = workflow.rawData['abnormalitiesPresent'];
                if (abnormalitiesPresentValue != null && abnormalitiesPresentValue) {
                    badges.push(<label key={'ecg-abnormal'} className='tag' style={{ backgroundColor: FormsStyles.orange, color: 'white' }}>ABNORMAL</label>);
                }

                if (badges.length == 0) {
                    badges.push(<label key={'ecg-normal'} className='tag' style={{ backgroundColor: FormsStyles.backgroundColor, color: FormsStyles.grey }}>NORMAL</label>);
                }

                return <span> {badges.map((badge) => {return badge;})} </span>;
            }

            case 'initialBloods': {
                let gender = workflow.rawData['patientSexInt'];
                if (gender != null) {
                    let troponinResult = workflow.rawData['initialBloodsTroponin'];
                    if (troponinResult != null) {
                        let troponin = TroponinResult.newTroponinResult(troponinResult);
                        let troponinStatus = troponin.getStatus(gender);
                        if (troponinStatus != null) {
                            return <label key={'initial-bloods'} className='tag' style={{ backgroundColor: troponinStatus == TroponinResult.Status.aboveCutoff ? FormsStyles.red  : FormsStyles.backgroundColor, color: troponinStatus != TroponinResult.Status.aboveCutoff ? FormsStyles.grey : 'white' }}>{troponin.statusTitle(troponinStatus).toUpperCase()}</label>;
                        }
                    }
                }
                return null;
            }
            case 'followUpBloods': {
                let gender = workflow.rawData['patientSexInt'];
                if (gender != null) {
                    let troponinResult = workflow.rawData['followUpBloodsTroponin'];
                    if (troponinResult != null) {
                        let troponin = TroponinResult.newTroponinResult(troponinResult);
                        let troponinStatus = troponin.getStatus(gender);
                        if (troponinStatus != null) {
                            return <label key={'followup-bloods'} className='tag' style={{ backgroundColor: troponinStatus == TroponinResult.Status.aboveCutoff ? FormsStyles.red  : FormsStyles.backgroundColor, color: troponinStatus != TroponinResult.Status.aboveCutoff ? FormsStyles.grey : 'white' }}>{troponin.statusTitle(troponinStatus).toUpperCase()}</label>;
                        }
                    }
                }
                return null;
            }
        }
    }

    stripSpecialChars(string){
        if(!string.includes('#@')){ return string; } 
        let components = string.split('#@');
        let strippedString = '';
        for(let component of components){
            if(component.includes('^')){
                let subComponents = component.split('^');
                strippedString += subComponents[1];
            } else {
                strippedString += component;
            }
        }
        return strippedString;
    }

    getSummary(workflow) {
        return (
            <div ref={node => this.node = node} className='form-summary-container form-page-container'>
                <div className='form-summary' ref={node => this.node = node}>
                    <div id='cardiac-chestpain'>

                        <PrintHeader forceVisibility={true} pathwayId={this.props.pathwayId}/> 

                        <div id='patient-details' className='summary-section avoidPageBreak'>
                            <h2 className='detail-list-title'>Patient</h2>
                            <div className='detail-list'>
                                <label className='list-title'>Sex</label>
                                <label className='list-detail'>{this.getReadableValue(workflow, 'patientSex', true)}</label>

                                <label className='list-title'>Age</label>
                                {workflow.rawData['patientAge'] == null &&
                                    <label className={'absent list-detail'}>[Age]</label>
                                }
                                {workflow.rawData['patientAge'] != null &&
                                    <label className='list-detail'>{Math.floor(workflow.rawData['patientAge']) + ' years'}</label>
                                }
                            </div>
                        </div>

                        <div id='structured-assesment' className='summary-section avoidPageBreak'>
                            <h2 className='detail-list-title'>Clinical question</h2>
                            <div className='detail-list'>
                                <label className='list-detail'>
                                    {workflow.rawData['clinicalSuspicionOfAcuteCoronorySyndrome'] == null ? '' : 'Clinical suspicion of Acute coronary syndrome: ' }{this.getReadableValue(workflow,'clinicalSuspicionOfAcuteCoronorySyndrome', true)}
                                </label>
                                <label className='list-title'>High-risk differential diagnoses</label>
                                {this.getItemsInSection(workflow, ['highRiskDifferentialDiagnosisSection'], true, 'present-items', '', '', true)}
                                {this.getItemsInSection(workflow, ['highRiskDifferentialDiagnosisSection'], false, 'not-present', 'Not present: ', '', false)}
                                {this.getItemsInSection(workflow, ['highRiskDifferentialDiagnosisSection'], null, 'absent', '[Not specified: ', ']', false)}
                            </div>
                        </div>

                        <div id='structured-assesment' className='summary-section avoidPageBreak'>
                            <h2 className='detail-list-title'>Initial assessment</h2>
                            <div className='detail-list'>
                                <label className='list-title'>Timing</label>
                                <label className='list-detail'>
                                    Pain onset {this.getReadableDate(workflow, 'firstDateTime', ' ddd DD-MMM-YYYY, HH:mm', false, true)}, lasting {this.getReadableValue(workflow,'firstDuration', true)}
                                </label>

                                {workflow.rawData['worstDateTime'] != null &&
                                    <label className='list-detail'>
                                        Worst pain {this.getReadableDate(workflow, 'worstDateTime', 'ddd DD-MMM-YYYY, HH:mm', false)}, lasting {this.getReadableValue(workflow, 'worstDuration')}
                                    </label>
                                }

                                <label className='list-title'>{'Symptoms and signs'}</label>
                                {this.getItemsInSection(workflow, ['symptomsAndSigns'], true, 'present-items', '', '', true)}
                                {this.getItemsInSection(workflow, ['symptomsAndSigns'], false, 'not-present', 'Not present: ', '', false)}
                                {this.getItemsInSection(workflow, ['symptomsAndSigns'], null, 'absent', '[Not specified: ', ']', false)}

                                <label className='list-title'>{'Key historical Information'}</label>
                                {this.getItemsInSection(workflow, ['problemsAndPast', 'familyHistory', 'medications'], true, 'present-items', '', '', true)}
                                {this.getItemsInSection(workflow, ['problemsAndPast', 'familyHistory', 'medications'], false, 'not-present', 'Not present: ', '', false)}
                                {this.getItemsInSection(workflow, ['problemsAndPast', 'familyHistory', 'medications'], null, 'absent', '[Not specified: ', ']', false)}
                            </div>
                        </div>

                        <div id='vitals' className='summary-section avoidPageBreak'>
                            <span className={'detail-list-span-horizontal'}><h2 className='detail-list-title'>Vitals</h2> {this.getTotalEWSBadge(workflow)}</span>
                            <div className='detail-list'>
                                {this.getVitals(workflow)}
                            </div>
                        </div>

                        <div id='investigations' className='summary-section avoidPageBreak'>
                            <h2 className='detail-list-title'>Investigations</h2>
                            <div className='detail-list'>
                                <span className='detail-list-span-horizontal'> <label className='actions-list-title'>{'ECG'}</label>{this.getBadgeValue('ecgTest', workflow)}</span>
                                <label className='list-title'>{'STEMI criteria'}</label>
                                {this.generateStemi(workflow)}
                                <label className='list-title'>{'Other abnormalities'}</label>
                                {this.generateAbnormalities(workflow)}

                                <label className='actions-list-title'>{'Bloods'}</label>
                                <span className="detail-list-span-vertical">
                                    <label className='list-title'>{'Troponin I - Initial'}</label>
                                    <span className='detail-list-span-horizontal'>
                                        {this.getReadableDate(workflow, 'initialBloodsDateAndTime', 'ddd DD-MMM-YYYY, HH:mm', true, true)}
                                        <label>, {this.getReadableValue(workflow,'initialBloodsTroponin', true)}</label>
                                        {this.getBadgeValue('initialBloods', workflow)}
                                    </span>
                                </span>

                                <span className="detail-list-span-vertical">
                                    <label className='list-title'>{'Troponin I - Follow-up'}</label>
                                    <span className='detail-list-span-horizontal'>
                                        {this.getReadableDate(workflow, 'followUpBloodsDateAndTime', 'ddd DD-MMM-YYYY, HH:mm', true)}
                                        <label>, {this.getReadableValue(workflow,'followUpBloodsTroponin', false)}</label>
                                        {this.getBadgeValue('followUpBloods', workflow)}
                                    </span>
                                </span>
                            </div>
                        </div>

                        <div id='red-flags' className='summary-section avoidPageBreak'>
                            <span className='detail-list-span-horizontal'><h2 className='detail-list-title'>Red flags</h2>{this.getRedFlagsBadge(workflow)}</span>
                            <div className='detail-list'>
                                <span className={'detail-list-span-vertical'}>
                                    {this.areRedFlagPresents(workflow) && 
                                        <span className='detail-list-span-vertical'> 
                                            {this.sectionContainsValue(workflow, [true, null], ['aorticDissectionPresentRedFlag', 'pulmonaryEmbolismRedFlag', 'pancreatitisRedFlag', 'pericarditisRedFlag', 'pneumothoraxRedFlag', 'cardiotoxicityRedFlag']) &&
                                                <span className='detail-list-span-vertical'>
                                                    <label className='list-title'>{'High-risk differential diagnoses'}</label>
                                                    {this.getDisparateItemsAsList(workflow, ['aorticDissectionPresentRedFlag', 'pulmonaryEmbolismRedFlag', 'pancreatitisRedFlag', 'pericarditisRedFlag', 'pneumothoraxRedFlag', 'cardiotoxicityRedFlag'], true, 'present-items', 'Actively considering', '', true)}
                                                    {this.getDisparateItemsAsList(workflow, ['aorticDissectionPresentRedFlag', 'pulmonaryEmbolismRedFlag', 'pancreatitisRedFlag', 'pericarditisRedFlag', 'pneumothoraxRedFlag', 'cardiotoxicityRedFlag'], null, 'absent', '[Not specified: ', ']', false)}
                                                </span>
                                            }
                                            {this.sectionContainsValue(workflow, [true, null], ['troponinAboveCutOff', 'newIschaemicChanges']) &&
                                                <span className='detail-list-span-vertical'>
                                                    <label className='list-title'>{'High-risk investigation'}</label>
                                                    {this.getDisparateItemsAsList(workflow, ['troponinAboveCutOff', 'newIschaemicChanges'], true, 'present-items', 'Actively considering', '', true)}
                                                    {this.getDisparateItemsAsList(workflow, ['troponinAboveCutOff', 'newIschaemicChanges'], null, 'absent', '[Not specified: ', ']', false)}
                                                </span>
                                            }
                                            {this.sectionContainsValue(workflow, [true, null], ['redFlagsOngoingChestPain', 'crescendoAngina', 'haemodynamicInstability']) &&
                                                <span className='detail-list-span-vertical'>
                                                    <label className='list-title'>{'High-risk findings'}</label>
                                                    {this.getDisparateItemsAsList(workflow, ['redFlagsOngoingChestPain', 'crescendoAngina', 'haemodynamicInstability'], true, 'present-items', 'Actively considering', '', true)}
                                                    {this.getDisparateItemsAsList(workflow, ['redFlagsOngoingChestPain', 'crescendoAngina', 'haemodynamicInstability'], null, 'absent', '[Not specified: ', ']', false)}
                                                </span>
                                            }
                                            {this.getDisparateItemsAsList(workflow, ['aorticDissectionPresentRedFlag', 'pulmonaryEmbolismRedFlag', 'pancreatitisRedFlag', 'pericarditisRedFlag', 'pneumothoraxRedFlag', 'cardiotoxicityRedFlag', 'troponinAboveCutOff', 'newIschaemicChanges', 'redFlagsOngoingChestPain', 'crescendoAngina', 'haemodynamicInstability'], false, 'not-present', 'Not actively considering: ', '', false)}
                                            {this.getRedFlagOverrideReasons(workflow)}
                                        </span>
                                    }
                                    {!this.areRedFlagPresents(workflow) && <label className='list-detail not-present'>No red flags</label>}
                                </span>
                            </div>
                        </div>

                        <div id='insights' className='summary-section avoidPageBreak'>
                            <h2 className='detail-list-title'>Outcome</h2>
                            <div className='detail-list'>
                                <span className='detail-list-span-horizontal'>
                                    <label className='list-title'>{'Calculated EDACS'}</label>
                                    {this.getCalculationBadge(workflow, CalculationModel.CalculationType.edacs, 'calculatedEDACS')}
                                </span>

                                <span className='detail-list-span-horizontal'>
                                    <label className='list-title'>{'Pathway Risk Category'}</label>
                                    {this.getCalculationBadge(workflow, CalculationModel.CalculationType.riskCategory, 'pathwayRiskCategory')}
                                </span>

                                {/* <span className='detail-list-span-horizontal'>
                                    <label className='list-title'>{'Probability of MACE'}</label>
                                    {this.getCalculationBadge(workflow, CalculationModel.CalculationType.probabilityOfMace, 'probabilityOfMACE')}
                                </span> */}

                            </div>
                        </div>

                        <div id='actions' className='summary-section avoidPageBreak'>
                            <h2 className='detail-list-title'>Actions</h2>
                            <div className='detail-list'>
                                <span className='detail-list-span-vertical'>
                                    {this.state.actions.length > 0 &&
                                        this.getActions()
                                    }
                                    {this.state.actions.length == 0 && <label className='list-detail not-present'>No actions</label>}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        let params = new URLSearchParams(window.location.search);
        let exportType = params.get('type');
        let workflow = this.props.workflows[this.props.pathwayId];
        let formSummaryFormat;
        if(workflow != null){
            if (exportType == 'JSON' || exportType == 'json') {
                formSummaryFormat = <div>{JSON.stringify(this.state.workflow.rawData)}</div>;
            } else {
                formSummaryFormat = this.getSummary(workflow);
            }
        }

        return (
            <div>
                {formSummaryFormat}
            </div>
        );
    }
}

GPChestPainSummary.propTypes = {
    workflows: PropTypes.object.isRequired,
    calculations: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    pathwayId: PropTypes.string.isRequired
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { workflows, updatingWorkflowPending, updatingWorkflowFulfilled, updatingWorkflowFailed } = state.workflowReducer;
    const { calculations } = state.calculationReducer;
    const { actions } = state.actionsReducer;
    return { workflows, updatingWorkflowPending, updatingWorkflowFulfilled, updatingWorkflowFailed, calculations, actions };
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({}, dispatch)
);

const hoc = withRouter(connect(mapStateToProps, mapDispatchToProps)(GPChestPainSummary));

// EXPORT COMPONENT

export { hoc as GPChestPainSummary };


// WEBPACK FOOTER //
// ./src/forms/gpChestPain01/Components/GPChestPain-Summary.js